import TextLoadingBox from 'LuxKit/Typography/TextLoadingBox'
import type { ComponentProps } from 'react'
import React from 'react'
import type PriceRowPrice from '../PriceRowPrice'

interface Props extends Pick<ComponentProps<typeof PriceRowPrice>, 'size'> {
}

const SIZES_HEADING_VARIANTS: Record<Props['size'], ComponentProps<typeof TextLoadingBox>['typography']> = {
  S: 'heading6',
  M: 'heading5',
  L: 'heading4',
}

function PriceRowLuxPlusPriceLoadingSkeleton(props: Props) {
  const { size } = props

  return <div>
    <TextLoadingBox typography={SIZES_HEADING_VARIANTS[size]} width="5ch" inline />
    {' '}
    <TextLoadingBox typography="caption-medium" width="12ch" inline />
  </div>
}

export default PriceRowLuxPlusPriceLoadingSkeleton
